export const LAUNCH_TEXT = 'Ready to Launch'
export const PENDING = 'pending'
export const SCHOOL_SETUP_TEXT = 'School Setup Required'
